<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-shtax-400 hover:text-shtax-600" :href="route('mailbox.mailings')">Newsletery i Mailingi</inertia-link>
      <span class="text-shtax-400 font-medium">/</span>
      Nowy newsleter
    </h1>
    <div class="flex flex-wrap">
      <div class="bg-white rounded-md shadow overflow-hidden w-full lg:w-1/2">
        <form @submit.prevent="store">
          <div class="p-8 -mr-6 -mb-8 flex flex-wrap">

            <text-input v-model="form.title" :error="form.errors.title" class="pr-6 pb-8 w-full" label="Tytuł wiadomości" />

            <text-input v-model="form.head_content" :error="form.errors.head_content" class="pr-6 pb-8 w-full" label="Nagłówek" />

            <div class="pb-8 pr-6 w-full">
              <label class="form-label">Treść wiadomości:</label>
              <vue-editor v-model="form.content" />

              <div class="w-1/2 form-error">
                <span v-if="form.errors.content">{{ form.errors.content }}</span>
              </div>
            </div>

            <shtax-checkbox class="pr-6 pb-6 w-full" v-model:checked.sync="form.is_send_planned" :error="form.errors.is_send_planned" :checked="form.is_send_planned" label="Zaplanuj wysyłkę" />

            <text-input v-model="form.start_sending_at_date" :error="form.errors.start_sending_at_date" class="pr-6 pb-8 w-full lg:w-1/2" label="Dzień wysyłki" type="date" :disabled="!form.is_send_planned" />
            <multiselect-input v-model="form.start_sending_at_time" :error="form.errors.start_sending_at_time" class="pr-6 pb-8 w-full lg:w-1/2" label="Godzina wysyłki" :options="hours" :multiple="false" :close_on_select="true" :isDisabled="!form.is_send_planned" />

            <shtax-checkbox class="pr-6 pb-6 w-full" v-model:checked.sync="form.is_sending_confirmed" :error="form.errors.is_sending_confirmed" :checked="form.is_sending_confirmed" label="Potwierdź przygotowanie do wysyłki" :disabled="!form.is_send_planned || form.start_sending_at_date == null || form.start_sending_at_time == null" />

            <multiselect-input v-model="form.filter" :error="form.errors.filter" class="pr-6 pb-8 w-full lg:w-full" label="Filtry wysyłki" :options="filters" track_by="key" opt_label="name" :multiple="false" :close_on_select="true" />

            <multiselect-input v-model="form.clients" :error="form.errors.clients" class="pr-6 pb-8 w-full lg:w-full" label="Wybierz klientów z listy" :options="clients" track_by="id" opt_label="nazwa_pelna" :multiple="true" :close_on_select="false" v-if="form.filter != null && form.filter.key == 'send_only_to_choosen_clients'" />

            <shtax-checkbox class="pr-6 pb-6 w-full" v-model:checked.sync="form.only_logged_user_clients" :error="form.errors.only_logged_user_clients" :checked="form.only_logged_user_clients" :label="'Tylko moich klientów ('+ $page.props.auth.user.first_name +' '+ $page.props.auth.user.last_name +')'" @update:checked="on_checked" />

            <multiselect-input v-model="form.users" :error="form.errors.users" class="pr-6 pb-8 w-full lg:w-full" label="Klienci opiekuna" :options="users" track_by="id" opt_label="name" :multiple="true" :close_on_select="false" :isDisabled="form.only_logged_user_clients" />

            <shtax-checkbox class="pr-6 pb-6 w-1/2" v-model:checked.sync="form.on_jdg" :error="form.errors.on_jdg" :checked="form.on_jdg" label="Tylko JDG" :disabled="form.on_companies" />

            <shtax-checkbox class="pr-6 pb-6 w-1/2" v-model:checked.sync="form.on_companies" :error="form.errors.on_companies" :checked="form.on_companies" label="Tylko spółki" :disabled="form.on_jdg" />

          </div>
          <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
            <loading-button :loading="form.processing" class="btn-shtax" type="submit" v-if="$page.props.can['add mailings']">Dodaj newsletter</loading-button>
          </div>
        </form>
      </div>
    </div>

  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import ShtaxCheckbox from '@/ShtaxComponents/Checkbox'
import { VueEditor } from "vue2-editor";
import MultiselectInput from '@/ShtaxComponents/MultiselectInput'

export default {
  metaInfo: { title: 'Nowy newsleter' },
  components: {
    LoadingButton,
    TextInput,
    ShtaxCheckbox,
    VueEditor,
    MultiselectInput
  },
  layout: Layout,
  props: {
    filters: Array,
    clients: Array,
    users: Array
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        title: null,
        head_content: null,
        content: null,
        is_send_planned: false,
        start_sending_at_date: null,
        start_sending_at_time: null,
        is_sending_confirmed: false,
        is_for_send: false,
        filter: null,
        only_logged_user_clients: false,
        clients: null,
        on_jdg: false,
        on_companies: false,
        users: null
      }),
      hours: [
        '0:00', '1:00', '2:00', '3:00', '4:00', '5:00', '6:00', '7:00', '8:00',
        '9:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', 
        '17:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00'
      ]
    }
  },
  methods: {
    store() {
      if (this.form.filter != null && this.form.filter.key != 'send_only_to_choosen_clients')
        this.form.clients = null;

      if (this.form.only_logged_user_clients)
        this.form.users = null;

      this.form.post(this.route('mailbox.mailings.store'))
    },

    on_checked() {
      this.form.users = null;
    }
  },

  created() {
    let today = new Date();
    this.form.start_sending_at_time = (today.getHours()+1) + ":00"
  },

}
</script>
